function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#828ff7",
  d: "M12 5V1c0-.55.45-1 1-1s1 .45 1 1v1h3c.55 0 1 .45 1 1s-.45 1-1 1h-3v1c0 .55-.45 1-1 1s-1-.45-1-1zm5 5H8V8h9c.55 0 1 .45 1 1s-.45 1-1 1zM5 6c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-1H1c-.55 0-1-.45-1-1s.45-1 1-1h3V7c0-.55.45-1 1-1zm4 12c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v1h7c.55 0 1 .45 1 1s-.45 1-1 1h-7v1c0 .55-.45 1-1 1zM1 2h9v2H1c-.55 0-1-.45-1-1s.45-1 1-1zm0 12h5v2H1c-.55 0-1-.45-1-1s.45-1 1-1z"
})));

var SvgMyFilter = function SvgMyFilter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMyFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my_filter.486b5469.svg";
export { ForwardRef as ReactComponent };